module.exports = __webpack_public_path__ + "static/img/company-7.2f0f4078.png";